import React from "react"
import {StaticQuery, graphql} from "gatsby"
import Img from "gatsby-image"
import ArrowImage from "./ArrowImage";

const MateAnnaSminkImage = () => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(relativePath: { eq: "portfolio/mate_anna.png" }) {
          childImageSharp {
            fluid(maxWidth: 300) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data =>
      <figure className="img-figure">
        <Img className="portfolio-img" fluid={data.placeholderImage.childImageSharp.fluid}
             alt="mateannasmink"/>
        <figcaption>
          <h1 className="title">Portfolio page for Mate Anna make-up artist</h1>
          <a className="button is-primary is-outlined is-rounded"
             href="https://mateannasmink.hu/"
             target="_blank"
             rel="noopener noreferrer">
            <span>Visit Website</span>
            <span
              className="icon">
                <ArrowImage/>
                </span>
          </a>
        </figcaption>
        <div className="overlay"/>
      </figure>
    }
  />
)
export default MateAnnaSminkImage
